// in src/posts.js
import React, { useEffect, useState } from 'react';

import { List, Datagrid, DeleteButton, TextInput, NumberInput, BooleanInput, Button, TopToolbar, required, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, SaveButton, FunctionField, useNotify, SelectInput, useUpdate, FormDataConsumer, Confirm, useInput } from 'react-admin';import { useTranslate  } from '../common/language';
import { apiUrl, contexts } from '../common/constants';
import { headersAPIObjectAuth } from '../common/utils';

import Typography from '@mui/material/Typography';



import Grid from '@mui/material/Grid';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GetAppIcon from '@material-ui/icons/GetApp';
import DnsIcon from '@mui/icons-material/Dns';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';


import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';


import { validateMaxLength, validateEmail } from './../components/Validator';

const SENDER_TYPE_CORREU_GESTIO_ENTITATS = 0;
const SENDER_TYPE_SMTP_GESTIO_ENTITATS = 1;
const SENDER_TYPE_SES_GESTIO_ENTITATS = 2;
const SENDER_TYPE_SMTP_PROPI = 3;
const SENDER_TYPE_SES_DOMINI_PROPI = 4;
const PLATFORM_ROLE_NONE = 'NONE';
const PLATFORM_ROLE_DEFAULT_GENERIC = 'DEFAULT_GENERIC';
const PLATFORM_ROLE_PLATFORM_SMTP = 'PLATFORM_SMTP';

const isSifacEntitiesDomain = () => ['entitats.sifac.cat', 'testentitats.sifac.cat'].includes(window.location.hostname);

const choicesSenderTypes = (translate, showGenericSender, onlyGenericSender, hidePlatformSmtp, hideOwnSmtp, disableSesOwnDomain) => [
  ...((showGenericSender || disableSesOwnDomain) ? [{ id: SENDER_TYPE_CORREU_GESTIO_ENTITATS, name: translate('senders.type_0'), desc: translate('senders.type_0_desc') }] : []),
  ...(onlyGenericSender ? [] : [
  ...(hidePlatformSmtp ? [] : [{ id: SENDER_TYPE_SMTP_GESTIO_ENTITATS, name: translate('senders.type_1'), desc: translate('senders.type_1_desc') }]),
  ...(hideOwnSmtp ? [] : [{ id: SENDER_TYPE_SMTP_PROPI, name: translate('senders.type_3'), desc: translate('senders.type_3_desc') }]),
  { id: SENDER_TYPE_SES_DOMINI_PROPI, name: translate('senders.type_4'), desc: translate('senders.type_4_desc'), disabled: disableSesOwnDomain },
  ]),
];

const choicesContexts = translate => [
  { id: contexts.GESTIOENTITATS, name: translate('senders.context_0') },
  { id: contexts.TICKETS, name: translate('senders.context_1') },
];

const senderTypeOptionText = choice => (
  <Box style={{ padding: '6px 0 10px 0' }}>
    <Typography variant="body2">{choice.name}</Typography>
    <Typography variant="caption" color="textSecondary">{choice.desc}</Typography>
  </Box>
);

const SenderTypeInput = ({ source, label, choices, validate }) => {
  const translate = useTranslate();
  const { id, input, meta, isRequired } = useInput({ source, validate });
  const inputError = meta.touched && (meta.error || meta.submitError);

  return (
    <FormControl component="fieldset" margin="dense" error={!!inputError} fullWidth>
      <FormLabel component="legend">{label}{isRequired ? ' *' : ''}</FormLabel>
      <RadioGroup
        id={id}
        value={input.value === null || input.value === undefined ? '' : String(input.value)}
        onChange={event => input.onChange(Number(event.target.value))}
      >
        {choices.map(choice => (
          <FormControlLabel
            key={choice.id}
            value={String(choice.id)}
            disabled={choice.disabled}
            control={<Radio color="primary" />}
            label={senderTypeOptionText(choice)}
          />
        ))}
      </RadioGroup>
      <FormHelperText>{inputError ? translate(inputError) : null}</FormHelperText>
    </FormControl>
  );
};

const normalizedSenderType = type => type === SENDER_TYPE_SES_GESTIO_ENTITATS || type == null ? SENDER_TYPE_CORREU_GESTIO_ENTITATS : type;

const senderTypeLabel = (translate, type) => translate('senders.type_' + normalizedSenderType(type));

const senderContextLabel = (translate, context) => translate('senders.context_' + (context === contexts.TICKETS ? contexts.TICKETS : contexts.GESTIOENTITATS));

const platformSenderEmail = () => window.location.hostname.includes('gestioentitats.cat')
  ? 'no-reply@gestioentitats.cat'
  : 'no-reply@sifac.cat';

const normalizeDnsValue = value => (value || '').replace(/^"+|"+$/g, '').trim();

const getSpfValue = values => (values || []).map(normalizeDnsValue).find(value => value.toLowerCase().startsWith('v=spf1'));

const mergeSpfValue = (currentValue, expectedValue) => {
  const current = normalizeDnsValue(currentValue);
  const expected = normalizeDnsValue(expectedValue);
  if (!current.toLowerCase().startsWith('v=spf1')) return expected;

  const expectedParts = expected.split(/\s+/).filter(part => part && part.toLowerCase() !== 'v=spf1' && !['~all', '-all', '+all', '?all'].includes(part.toLowerCase()));
  const currentParts = current.split(/\s+/);
  const currentLower = currentParts.map(part => part.toLowerCase());
  const allIndex = currentParts.findIndex(part => ['~all', '-all', '+all', '?all'].includes(part.toLowerCase()));
  const additions = expectedParts.filter(part => !currentLower.includes(part.toLowerCase()));

  if (additions.length === 0) return current;
  if (allIndex >= 0) {
    return [
      ...currentParts.slice(0, allIndex),
      ...additions,
      ...currentParts.slice(allIndex)
    ].join(' ');
  }
  return [...currentParts, ...additions].join(' ');
};

const recommendedDnsValue = item => {
  if (item.type !== 'TXT' || !normalizeDnsValue(item.value).toLowerCase().startsWith('v=spf1')) {
    return item.value;
  }
  const currentSpf = getSpfValue(item.current_values);
  return currentSpf ? mergeSpfValue(currentSpf, item.value) : item.value;
};

const displayedDnsValues = item => {
  const values = item.current_values || [];
  if (item.type === 'TXT' && normalizeDnsValue(item.value).toLowerCase().startsWith('v=spf1')) {
    return values.filter(value => normalizeDnsValue(value).toLowerCase().startsWith('v=spf1'));
  }
  return values;
};

const dnsCurrentValuesText = item => {
  const values = displayedDnsValues(item).map(normalizeDnsValue).filter(value => value);
  return values.length > 0 ? values.join('\n') : '-';
};

const copyTextToClipboard = async text => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};

const dnsTableStyles = {
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '8px',
    tableLayout: 'fixed'
  },
  labelCell: {
    width: '190px',
    padding: '8px',
    border: '1px solid #e0e0e0',
    backgroundColor: '#f7f7f7',
    verticalAlign: 'top'
  },
  valueCell: {
    padding: '8px',
    border: '1px solid #e0e0e0',
    verticalAlign: 'top',
    wordBreak: 'break-all',
    whiteSpace: 'pre-line'
  }
};

const hasDnsConfiguration = (record, isSuperAdmin) => record && (
  record.type === SENDER_TYPE_SMTP_GESTIO_ENTITATS ||
  (isSuperAdmin && record.type === SENDER_TYPE_SMTP_PROPI) ||
  record.type === SENDER_TYPE_SES_DOMINI_PROPI ||
  record.type == null
);

const dnsNoRecordsTranslationKey = record =>
  record && record.type === SENDER_TYPE_SES_DOMINI_PROPI
    ? 'senders.dns_ses_not_enabled'
    : 'senders.dns_no_records';

const hasSmtpTest = (record, isSuperAdmin) => record && (
  record.type === SENDER_TYPE_SMTP_PROPI ||
  (isSuperAdmin && normalizedSenderType(record.type) === SENDER_TYPE_CORREU_GESTIO_ENTITATS)
);

const senderEmailLabel = (translate, record, isSuperAdmin) => {
  if (!isSuperAdmin && normalizedSenderType(record.type) === SENDER_TYPE_CORREU_GESTIO_ENTITATS) {
    return translate('senders.platform_sender');
  }
  return isSuperAdmin && record.name
    ? `${record.name} <${record.email}>`
    : record.email;
};

const formatDateTime = value => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString();
};

const isValidEmailForValidation = email => {
  const value = (email || '').trim();
  return value.length > 3 && value.includes('@') && value.indexOf('@') > 0 && value.lastIndexOf('.') > value.indexOf('@') + 1 && !value.toLowerCase().startsWith('copia ');
};

const defaultSmtpValues = {
  smtp_host: '',
  smtp_port: 587,
  smtp_username: '',
  smtp_pswd: '',
  protocol: 'smtp',
  auth: true,
  starttls: true,
  ssl: 'TLSv1.2',
  debug: false
};

export const SettingsSenders = (props) => <SendersSettingsPage {...props} smtpSettingsMode={false} />;

export const SettingsSmtp = (props) => <SendersSettingsPage {...props} smtpSettingsMode />;

const SendersSettingsPage = (props) => {
  const translate = useTranslate();    
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  const smtpSettingsMode = Boolean(props.smtpSettingsMode);
  const listFilter = smtpSettingsMode
    ? { associations_id: 0, platform_role: PLATFORM_ROLE_PLATFORM_SMTP }
    : {
        associations_id : isSuperAdmin ? 0 : localStorage.getItem('associations_id'),
        ...(isSuperAdmin ? { exclude_platform_role: PLATFORM_ROLE_PLATFORM_SMTP } : {})
      };
    
  let strRedirect = smtpSettingsMode ? '/settings-smtp' : '/settings-senders';  
    
  return (
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate(smtpSettingsMode ? 'senders.smtp_settings_desc' : 'senders.desc')}              
      </Typography>
      <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box" >
        <ResourceContextProvider value="senders">
          <List {...props} 
            basePath="/senders"             
            actions={<ListActionsSendersList smtpSettingsMode={smtpSettingsMode}/>}    
            filter={listFilter}  
            bulkActionButtons={false}  
            pagination={false}
            empty={<ListActionsSendersList smtpSettingsMode={smtpSettingsMode} />} 
            fullWidth
          >        
            <Datagrid fullWidth>            
              {smtpSettingsMode ? <FunctionField render={record => senderContextLabel(translate, record.context)} label={translate('senders.context')} sortable={false} /> : <FunctionField render={record => senderEmailLabel(translate, record, isSuperAdmin)} label={translate('senders.email')} sortable={false} />}
              {isSuperAdmin && !smtpSettingsMode ? <FunctionField render={record => senderContextLabel(translate, record.context) } label={translate('senders.context')} sortable={false} /> : null}
              {smtpSettingsMode ? null : <FunctionField render={record => senderTypeLabel(translate, record.type) } label={translate('senders.type')} sortable={false} />}
              {isSuperAdmin && !smtpSettingsMode ? <FunctionField render={record => <DefaultSenderStatus record={record} />} label={translate('senders.default_sender')} sortable={false} /> : null}
              {smtpSettingsMode ? <FunctionField render={record => <SmtpActiveStatus record={record} />} label={translate('senders.smtp_active')} sortable={false} /> : <FunctionField render={record => <SenderValidationStatus record={record} isSuperAdmin={isSuperAdmin} />} label={translate('senders.actived')} sortable={false}  />}                
              {smtpSettingsMode ? null : <FunctionField render={record => hasDnsConfiguration(record, isSuperAdmin) ? <DnsConfigurationStatus record={record} /> : null} label={translate('senders.dns_configuration')} sortable={false} />}
              <FunctionField render={record => hasSmtpTest(record, isSuperAdmin) ? <SmtpTestStatus record={record} /> : null} label={translate('senders.smtp_test')} sortable={false} />
              <FunctionField render={record => <SenderActions record={record} redirect={strRedirect} />} label={translate('common.actions')} sortable={false} />
            </Datagrid>        
          </List>
        </ResourceContextProvider>
      </Box>
    </>
  );
};

const ListActionsSendersList = ({ smtpSettingsMode }) => {
  const translate = useTranslate(); 
  return (
    <TopToolbar>     
      <SendersCreateButton smtpSettingsMode={smtpSettingsMode} />      
    </TopToolbar>
  );
};


const SendersCreateButton = ({ smtpSettingsMode }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [createdDnsRecord, setCreatedDnsRecord] = useState(null);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  const disableSesOwnDomain = isSifacEntitiesDomain();

  const [create, { loading }] = useCreate('senders');

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          if (normalizedSenderType(data.type) === SENDER_TYPE_SES_DOMINI_PROPI) {
            setCreatedDnsRecord(data);
          }
          refresh();
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };    

  return (
    <>            
      <Button onClick={handleClick} label={translate(smtpSettingsMode ? 'senders.smtp_settings_create' : 'senders.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate(smtpSettingsMode ? 'senders.smtp_settings_create' : 'senders.create')}
        className="dialog-md"
        maxWidth="md"
      >
        <DialogTitle>{translate(smtpSettingsMode ? 'senders.smtp_settings_create' : 'senders.create')}</DialogTitle>

        <FormWithRedirect
          resource="senders"
          save={handleSubmit}
          initialValues={ {
            associations_id : isSuperAdmin ? 0 : localStorage.getItem('associations_id'),
            context: contexts.GESTIOENTITATS,
            type: smtpSettingsMode ? SENDER_TYPE_SMTP_PROPI : isSuperAdmin ? SENDER_TYPE_SMTP_GESTIO_ENTITATS : disableSesOwnDomain ? SENDER_TYPE_CORREU_GESTIO_ENTITATS : SENDER_TYPE_SES_DOMINI_PROPI,
            email: '',
            actived: smtpSettingsMode ? true : undefined,
            default_sender: false,
            platform_role: smtpSettingsMode ? PLATFORM_ROLE_PLATFORM_SMTP : PLATFORM_ROLE_NONE,
            ...defaultSmtpValues
          } }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent emailDisabled={false} hideEmail={smtpSettingsMode} allowPlatformSmtp={isSuperAdmin} showGenericSender={!isSuperAdmin} onlyGenericSender={false} showContext={isSuperAdmin} showName={isSuperAdmin && !smtpSettingsMode} showDefaultSender={isSuperAdmin && !smtpSettingsMode} showSmtpActive={smtpSettingsMode} hidePlatformSmtp={false} hideOwnSmtp={isSuperAdmin && !smtpSettingsMode} hideType={smtpSettingsMode} forceSmtpSettings={smtpSettingsMode} disableSesOwnDomain={disableSesOwnDomain} />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
      {createdDnsRecord ? (
        <DnsConfigurationButton
          record={createdDnsRecord}
          autoOpen
          hideButton
          onClose={() => setCreatedDnsRecord(null)}
        />
      ) : null}
    </>
  );
};

const FormContent = ({ emailDisabled, hideEmail, allowPlatformSmtp, showGenericSender, onlyGenericSender, showContext, showName, showDefaultSender, showSmtpActive, hidePlatformSmtp, hideOwnSmtp, hideType, forceSmtpSettings, disableSesOwnDomain }) => {

  const translate = useTranslate(); 
  
  return (
    <DialogContent>
      <FormDataConsumer>
        {({ formData }) => {
          const isPlatformSender = normalizedSenderType(formData.type) === SENDER_TYPE_CORREU_GESTIO_ENTITATS;
          const isOwnSmtpSender = normalizedSenderType(formData.type) === SENDER_TYPE_SMTP_PROPI;
          const showSmtpSettings = forceSmtpSettings || isOwnSmtpSender || (allowPlatformSmtp && isPlatformSender);
          return (
            <Grid container spacing={2}>
              {showContext ? (
                <Grid item xs={12} md={showSmtpActive ? 6 : 12}>
                  <SelectInput fullWidth source="context" label={translate('senders.context')} choices={choicesContexts(translate)} validate={[required()]} />
                </Grid>
              ) : null}
              {showName ? (
                <Grid item xs={12} md={6}>
                  <TextInput fullWidth source="name" label={translate('senders.name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  {formData.context === contexts.TICKETS ? (
                    <Typography variant="caption" color="textSecondary">
                      {translate('senders.name_vars')}
                    </Typography>
                  ) : null}
                </Grid>
              ) : null}
              {hideEmail ? null : isPlatformSender && !showName ? null : isPlatformSender ? (
                <Grid item xs={12} md={showName ? 6 : 12}>
                  <Typography variant="body2">
                    {translate('senders.email')}: <b>{formData.email || platformSenderEmail()}</b>
                  </Typography>
                </Grid>
              ) : (
                <Grid item xs={12} md={showName ? 6 : 12}>     
                  <TextInput fullWidth source="email" label={translate('senders.email')} disabled={emailDisabled} validate={[required(),validateEmail(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
              )}
              {hideType ? null : (
                <Grid item xs={12}>     
                  <SenderTypeInput source="type" label={translate('senders.type')} validate={[required()]} choices={choicesSenderTypes(translate, showGenericSender, onlyGenericSender, hidePlatformSmtp, hideOwnSmtp, disableSesOwnDomain)} />
                </Grid>
              )}
              {showDefaultSender ? (
                <Grid item xs={12}>
                  <BooleanInput fullWidth source="default_sender" label={translate('senders.default_sender')} />
                </Grid>
              ) : null}
              {showSmtpActive ? (
                <Grid item xs={12} md={showContext ? 6 : 12}>
                  <BooleanInput fullWidth source="actived" label={translate('senders.smtp_active')} />
                </Grid>
              ) : null}
              {showSmtpSettings ? (
                <>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2">{translate('senders.smtp_configuration')}</Typography>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextInput fullWidth source="smtp_host" label={translate('senders.smtp_host')} validate={[required(), validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                  <Grid item xs={6} md={2}>
                    <NumberInput fullWidth source="smtp_port" label={translate('senders.smtp_port')} validate={[required()]} />
                  </Grid>
                  <Grid item xs={6} md={2}>
                    <TextInput fullWidth source="protocol" label={translate('senders.smtp_protocol')} />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextInput fullWidth source="ssl" label={translate('senders.smtp_ssl')} />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextInput fullWidth source="smtp_username" label={translate('senders.smtp_username')} autoComplete="new-smtp-username" inputProps={{ autoComplete: 'new-smtp-username' }} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextInput fullWidth source="smtp_pswd" label={translate('senders.smtp_pswd')} autoComplete="off" inputProps={{ autoComplete: 'off' }} />
                  </Grid>
                  <Grid item xs={6} md={2}>
                    <BooleanInput fullWidth source="auth" label={translate('senders.smtp_auth')} />
                  </Grid>
                  <Grid item xs={6} md={2}>
                    <BooleanInput fullWidth source="starttls" label={translate('senders.smtp_starttls')} />
                  </Grid>
                </>
              ) : null}
            </Grid>
          );
        }}
      </FormDataConsumer>
    </DialogContent>
  );
};

const ApplySenderToTemplatesButton = ({ record }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const disabled = loading || !record.actived;

  const handleClick = async () => {
    if (!record.actived) {
      return;
    }
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/senders/${record.id}/templates/apply`, {
        method: 'POST',
        headers: headersAPIObjectAuth(),
        cache: 'no-store'
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message || json.msg || 'Error connectant amb la API...');
      }
      notify(json.msg || translate('senders.apply_templates_ok'), 'info');
      refresh();
      setOpen(false);
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="button" onClick={handleClick} label="" title={translate(record.actived ? 'senders.apply_templates' : 'senders.apply_templates_disabled')} disabled={disabled}>
        <LibraryAddCheckIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={translate('senders.apply_templates')}
        content={translate('senders.apply_templates_confirm')}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};

const SenderActions = ({ record, redirect }) => {
  const translate = useTranslate();
  const canApplyToTemplates = record.platform_role !== PLATFORM_ROLE_PLATFORM_SMTP;

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {canApplyToTemplates ? <ApplySenderToTemplatesButton record={record} /> : null}
      {normalizedSenderType(record.type) !== SENDER_TYPE_CORREU_GESTIO_ENTITATS && record.platform_role !== PLATFORM_ROLE_PLATFORM_SMTP ? <DuplicateSenderButton record={record} /> : null}
      <SendersEditButton record={record} />
      <DeleteButton record={record} undoable={false} redirect={redirect} label="" title={translate('senders.delete')} />
    </Box>
  );
};

const SenderValidationStatus = ({ record, isSuperAdmin }) => {
  const translate = useTranslate();
  const senderType = normalizedSenderType(record.type);
  const canRequestValidation = !isSuperAdmin
    && !record.actived
    && senderType !== SENDER_TYPE_CORREU_GESTIO_ENTITATS;
  const tooltipTitle = record.actived && record.actived_at
    ? `${translate('senders.validated_at')} ${formatDateTime(record.actived_at)}`
    : translate(record.actived ? 'senders.actived_1' : 'senders.actived_0');

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <Tooltip title={tooltipTitle}>
        <span style={{ display: 'inline-flex' }}>
          {record.actived ? <CheckCircleIcon style={{ color: '#2e7d32' }} /> : <CancelIcon style={{ color: '#c62828' }} />}
        </span>
      </Tooltip>
      {canRequestValidation ? <RequestSenderValidationInfoButton record={record} /> : null}
    </Box>
  );
};

const SmtpActiveStatus = ({ record }) => {
  const translate = useTranslate();
  return (
    <Tooltip title={translate(record.actived ? 'senders.smtp_active_yes' : 'senders.smtp_active_no')}>
      <span style={{ display: 'inline-flex' }}>
        {record.actived ? <CheckCircleIcon style={{ color: '#2e7d32' }} /> : <CancelIcon style={{ color: '#c62828' }} />}
      </span>
    </Tooltip>
  );
};

const DefaultSenderStatus = ({ record }) => {
  return (
    <span style={{ display: 'inline-flex' }}>
      {record.default_sender ? <CheckCircleIcon style={{ color: '#2e7d32' }} /> : <CancelIcon style={{ color: '#c62828' }} />}
    </span>
  );
};

const RequestSenderValidationInfoButton = ({ record }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const emailValid = isValidEmailForValidation(record.email);

  const handleClick = () => {
    if (!emailValid) {
      return;
    }
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/senders/${record.id}/validation/request`, {
        method: 'POST',
        headers: headersAPIObjectAuth(),
        cache: 'no-store'
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message || json.msg || 'Error connectant amb la API...');
      }
      notify(json.msg || translate('senders.validation_request_ok'), 'info');
      setOpen(false);
      refresh();
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="button" onClick={handleClick} label="" title={translate(emailValid ? 'senders.validation_request' : 'senders.validation_request_disabled')} disabled={loading || !emailValid}>
        <InfoIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={translate('senders.validation_request')}
        content={translate('senders.validation_request_confirm')}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};

const DuplicateSenderButton = ({ record }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();

  const handleClick = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/senders/${record.id}/duplicate`, {
        method: 'POST',
        headers: headersAPIObjectAuth(),
        cache: 'no-store'
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message || 'Error connectant amb la API...');
      }
      notify(translate('senders.duplicate_ok'), 'info');
      setOpen(false);
      refresh();
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="button" onClick={handleClick} label="" title={translate('senders.duplicate')} disabled={loading}>
        <FileCopyIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={translate('senders.duplicate')}
        content={translate('senders.duplicate_confirm')}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};

const SendersEditButton = ({ record }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [smtpConfig, setSmtpConfig] = useState({});
  const [formKey, setFormKey] = useState(0);
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  const isPlatformSmtpConfig = record.platform_role === PLATFORM_ROLE_PLATFORM_SMTP;
  const [update, { loading }] = useUpdate();

  const handleOpen = async () => {
    let config = {};
    try {
      const response = await fetch(`${apiUrl}/senders/${record.id}/smtp`, {
        headers: headersAPIObjectAuth(),
        cache: 'no-store'
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message || 'Error connectant amb la API...');
      }
      config = json || {};
    } catch (error) {
      notify(error.message, 'error');
    }
    setSmtpConfig(config);
    setFormKey(new Date().getTime());
    setShowDialog(true);
  };

  const handleSubmit = async values => {
    update(
      {
        type: 'update',
        resource: 'senders',
        payload: { id: values.id, data: values }
      },
      {
        onSuccess: () => {
          setShowDialog(false);
          refresh();
        },
        onFailure: error => {
          notify(error.message, 'error');
        }
      }
    );
  };

  return (
    <>
      <Button onClick={handleOpen} label="" title={translate('senders.edit')}>
        <EditIcon />
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('senders.edit')}
        className="dialog-md"
        maxWidth="md"
      >
        <DialogTitle>{translate(isPlatformSmtpConfig ? 'senders.smtp_settings_edit' : 'senders.edit')}</DialogTitle>
        <FormWithRedirect
          key={formKey}
          resource="senders"
          save={handleSubmit}
          initialValues={{ ...defaultSmtpValues, ...record, ...smtpConfig, type: normalizedSenderType(record.type) }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <FormContent emailDisabled={normalizedSenderType(record.type) === SENDER_TYPE_CORREU_GESTIO_ENTITATS} hideEmail={isPlatformSmtpConfig} allowPlatformSmtp={isSuperAdmin} showGenericSender={normalizedSenderType(record.type) === SENDER_TYPE_CORREU_GESTIO_ENTITATS} onlyGenericSender={normalizedSenderType(record.type) === SENDER_TYPE_CORREU_GESTIO_ENTITATS} showContext={isSuperAdmin} showName={isSuperAdmin && !isPlatformSmtpConfig} showDefaultSender={isSuperAdmin && !isPlatformSmtpConfig} showSmtpActive={isPlatformSmtpConfig} hidePlatformSmtp={false} hideOwnSmtp={isSuperAdmin && !isPlatformSmtpConfig} hideType={isPlatformSmtpConfig} forceSmtpSettings={isPlatformSmtpConfig} disableSesOwnDomain={isSifacEntitiesDomain()} />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const DnsConfigurationStatus = ({ record }) => {
  const [dnsVerified, setDnsVerified] = useState(record.dns_verified);
  const [dnsVerifiedAt, setDnsVerifiedAt] = useState(record.dns_verified_at);
  const translate = useTranslate();
  const tooltipTitle = dnsVerified && dnsVerifiedAt
    ? `${translate('senders.dns_verified_at')} ${formatDateTime(dnsVerifiedAt)}`
    : translate('senders.dns_not_verified_tooltip');

  const handleChecked = (valid, verifiedAt) => {
    setDnsVerified(valid);
    setDnsVerifiedAt(verifiedAt);
  };

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <Tooltip title={tooltipTitle}>
        <span style={{ display: 'inline-flex' }}>
          {dnsVerified ? <CheckCircleIcon style={{ color: '#2e7d32' }} /> : <CancelIcon style={{ color: '#c62828' }} />}
        </span>
      </Tooltip>
      <DnsConfigurationButton record={record} onChecked={handleChecked} />
    </Box>
  );
};

const SmtpTestStatus = ({ record }) => {
  const [smtpVerified, setSmtpVerified] = useState(record.smtp_verified);
  const [smtpVerifiedAt, setSmtpVerifiedAt] = useState(record.smtp_verified_at);
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const translate = useTranslate();
  const tooltipTitle = smtpVerifiedAt
    ? `${translate('senders.smtp_verified_at')} ${formatDateTime(smtpVerifiedAt)}`
    : translate('senders.smtp_not_verified_tooltip');

  const handleTest = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/senders/${record.id}/smtp/test`, {
        method: 'POST',
        headers: headersAPIObjectAuth(),
        cache: 'no-store'
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message || json.msg || 'Error connectant amb la API...');
      }
      const verifiedAt = new Date().toISOString();
      setSmtpVerified(Boolean(json.done));
      setSmtpVerifiedAt(verifiedAt);
      notify(json.msg || (json.done ? translate('senders.smtp_test_ok') : translate('senders.smtp_test_ko')), json.done ? 'info' : 'warning');
    } catch (error) {
      setSmtpVerified(false);
      setSmtpVerifiedAt(new Date().toISOString());
      notify(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <Tooltip title={tooltipTitle}>
        <span style={{ display: 'inline-flex' }}>
          {smtpVerified ? <CheckCircleIcon style={{ color: '#2e7d32' }} /> : <CancelIcon style={{ color: '#c62828' }} />}
        </span>
      </Tooltip>
      <Button type="button" onClick={handleTest} label="" title={translate('senders.smtp_test')} disabled={loading}>
        <RefreshIcon />
      </Button>
    </Box>
  );
};

const CopyDnsValueButton = ({ value }) => {
  const notify = useNotify();
  const translate = useTranslate();

  const handleCopy = async () => {
    try {
      await copyTextToClipboard(value || '');
      notify(translate('utils.copy_clipboard_success'), 'info');
    } catch (error) {
      notify(translate('utils.copy_clipboard_error'), 'warning');
    }
  };

  return (
    <Button type="button" onClick={handleCopy} label="" title={translate('common.copy')} disabled={!value}>
      <FileCopyIcon />
    </Button>
  );
};

const DnsConfigurationButton = ({ record, onChecked, autoOpen = false, hideButton = false, onClose }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [dnsConfig, setDnsConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const translate = useTranslate();
  const isOwnSmtpDns = record && record.type === SENDER_TYPE_SMTP_PROPI;

  const loadConfig = async check => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/senders/${record.id}/dns?check=${check ? 'true' : 'false'}&_=${new Date().getTime()}`, {
        headers: {
          ...headersAPIObjectAuth(),
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        },
        cache: 'no-store'
      });
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message || 'Error connectant amb la API...');
      }
      setDnsConfig(json);
      if (check && onChecked) onChecked(json.valid, json.valid ? new Date().toISOString() : null);
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = () => {
    setShowDialog(true);
    loadConfig(true);
  };

  const handleClose = () => {
    setShowDialog(false);
    if (onClose) onClose();
  };

  const handleCheck = () => {
    loadConfig(true);
  };

  const handleDownloadDnsPdf = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/senders/${record.id}/dns/pdf`, {
        headers: {
          ...headersAPIObjectAuth(),
          'Accept': 'application/pdf'
        }
      });

      if (!response.ok) {
        let message = translate('senders.dns_download_error');
        try {
          const json = await response.json();
          message = json.message || message;
        } catch (error) {}
        throw new Error(message);
      }

      const blob = await response.blob();
      const disposition = response.headers.get('Content-Disposition') || '';
      const filenameMatch = disposition.match(/filename="?([^";]+)"?/);
      const filename = filenameMatch ? filenameMatch[1] : `configuracio-dns-${record.id}.pdf`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      notify(translate('common.download_ok'), 'info');
    } catch (error) {
      notify(error.message || translate('senders.dns_download_error'), 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoOpen && record && record.id) {
      handleOpen();
    }
  }, [autoOpen, record && record.id]);

  return (
    <>
      {!hideButton ? (
        <Button type="button" onClick={handleOpen} label="" title={translate('senders.dns_configuration')}>
          <InfoIcon />
        </Button>
      ) : null}

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleClose}
        aria-label={translate('senders.dns_configuration')}
        className="dialog-md"
        maxWidth="md"
      >
        <DialogTitle>{translate('senders.dns_configuration')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="button" label={translate('senders.dns_download_document')} onClick={handleDownloadDnsPdf} disabled={loading || !record || !record.id}>
                  <GetAppIcon />
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="grey8">
                {translate(isOwnSmtpDns ? 'senders.dns_configuration_help_smtp_own' : 'senders.dns_configuration_help')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2">{translate('senders.domain')}: {dnsConfig && dnsConfig.domain ? dnsConfig.domain : '-'}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Box>
                {dnsConfig && dnsConfig.records && dnsConfig.records.length > 0 ? dnsConfig.records.map((item, index) => (
                  <Box key={index} style={{ borderBottom: '1px solid #e0e0e0', padding: '10px 0' }}>
                    <table style={dnsTableStyles.table}>
                      <tbody>
                        <tr>
                          <td style={dnsTableStyles.labelCell}>
                            <Typography variant="caption" display="block">{translate('senders.dns_record_type')}</Typography>
                          </td>
                          <td style={dnsTableStyles.valueCell}>
                            <Typography variant="body2" style={{ fontWeight: 700 }}>{item.type}</Typography>
                          </td>
                        </tr>
                        <tr>
                          <td style={dnsTableStyles.labelCell}>
                            <Typography variant="caption" display="block">{translate('senders.domain')}</Typography>
                          </td>
                          <td style={dnsTableStyles.valueCell}>
                            <Box style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                              <Typography variant="body2" style={{ flex: 1, fontWeight: 700 }}>{item.name}</Typography>
                              <CopyDnsValueButton value={item.name} />
                            </Box>
                          </td>
                        </tr>
                        {!isOwnSmtpDns ? (
                          <tr>
                            <td style={dnsTableStyles.labelCell}>
                              <Typography variant="caption" display="block">{translate('senders.dns_record_value')}</Typography>
                            </td>
                            <td style={dnsTableStyles.valueCell}>
                              <Typography variant="body2" style={{ fontWeight: 700 }}>{item.value}</Typography>
                            </td>
                          </tr>
                        ) : null}
                        {dnsConfig.checked ? (
                          <tr>
                            <td style={dnsTableStyles.labelCell}>
                              <Typography variant="caption" display="block">{translate('senders.dns_status')}</Typography>
                            </td>
                            <td style={dnsTableStyles.valueCell}>
                              <Typography variant="body2" style={{ color: item.found ? '#2e7d32' : '#c62828' }}>
                                {item.found ? translate('senders.dns_found') : translate('senders.dns_not_found')}
                              </Typography>
                            </td>
                          </tr>
                        ) : null}
                        {dnsConfig.checked ? (
                          <tr>
                            <td style={dnsTableStyles.labelCell}>
                              <Typography variant="caption" display="block">{translate('senders.dns_current_values')}</Typography>
                            </td>
                            <td style={dnsTableStyles.valueCell}>
                              <Typography variant="body2">{dnsCurrentValuesText(item)}</Typography>
                            </td>
                          </tr>
                        ) : null}
                        {!isOwnSmtpDns ? (
                          <tr>
                            <td style={dnsTableStyles.labelCell}>
                              <Typography variant="caption" display="block">{translate('senders.dns_recommended_value')}</Typography>
                            </td>
                            <td style={dnsTableStyles.valueCell}>
                              <Box style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                                <Typography variant="body2" style={{ flex: 1 }}>{recommendedDnsValue(item)}</Typography>
                                <CopyDnsValueButton value={recommendedDnsValue(item)} />
                              </Box>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                    {!isOwnSmtpDns && dnsConfig.checked && item.type === 'TXT' && normalizeDnsValue(item.value).toLowerCase().startsWith('v=spf1') ? (
                      <Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: '4px' }}>
                        {translate('senders.dns_spf_merge_help')}
                      </Typography>
                    ) : null}
                  </Box>
                )) : (
                  <Typography variant="body2">{dnsConfig && dnsConfig.message ? dnsConfig.message : translate(dnsNoRecordsTranslationKey(record))}</Typography>
                )}
              </Box>
            </Grid>
            {dnsConfig && dnsConfig.checked ? (
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={{ color: dnsConfig.valid ? '#2e7d32' : '#c62828' }}>
                  {dnsConfig.valid ? translate('senders.dns_valid') : translate('senders.dns_invalid')}
                </Typography>
              </Grid>
            ) : null}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button label="ra.action.cancel" onClick={handleClose} disabled={loading}>
            <IconCancel />
          </Button>
          <Button type="button" label={translate('senders.dns_check')} onClick={handleCheck} disabled={loading || !dnsConfig}>
            <DnsIcon />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};



